/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Contact API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContactResponse,
    ContactResponseFromJSON,
    ContactResponseFromJSONTyped,
    ContactResponseToJSON,
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedContactResponseList
 */
export interface PaginatedContactResponseList {
    /**
     * 
     * @type {Pagination}
     * @memberof PaginatedContactResponseList
     */
    pagination: Pagination;
    /**
     * 
     * @type {Array<ContactResponse>}
     * @memberof PaginatedContactResponseList
     */
    data?: Array<ContactResponse>;
}

export function PaginatedContactResponseListFromJSON(json: any): PaginatedContactResponseList {
    return PaginatedContactResponseListFromJSONTyped(json, false);
}

export function PaginatedContactResponseListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedContactResponseList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pagination': PaginationFromJSON(json['pagination']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ContactResponseFromJSON)),
    };
}

export function PaginatedContactResponseListToJSON(value?: PaginatedContactResponseList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pagination': PaginationToJSON(value.pagination),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ContactResponseToJSON)),
    };
}


